module.exports = __webpack_public_path__ + "static/template_options_1_day_no_overlay-b63afd40ee00d5389fc79927db9e760c.png";